module.exports = __webpack_public_path__ + "static/wand_of_magic_missiles-141f1e80f21ba1a92b3b8ff9d5ce8ca1.jpeg";